import { IComment } from '@shared/models/comment.model';
import { IDataTable } from '@shared/models/data-table.model';
import { IProduct } from '@shared/models/product.model';
import { IProjectInfo } from '@shared/models/project.model';
import { Recipe } from '@shared/models/recipe.model';
import { SemiPartial, ValidIdItem } from '@shared/models/type-helpers.model';

export enum UpdateClientAction {
  Add = 'add',
  Update = 'update',
  Remove = 'remove',
}

export type UpdateClientData<T> =
  | { action: UpdateClientAction.Add | UpdateClientAction.Update; itemOrId: T }
  | { action: UpdateClientAction.Remove; itemOrId: string | number }
  | { action?: null; itemOrId?: null };

export type CollectionTypes =
  IComment | IProduct | Recipe | IProjectInfo | IDataTable;

export type UpdateClientCollectionData<T extends CollectionTypes> = {
  collection?: T[];
  lookup?: Record<string, T>;
};

export type UpdateClientDataFn = <T extends CollectionTypes>(
  args: UpdateClientData<T> & UpdateClientCollectionData<T>,
) => UpdateClientCollectionData<T>;

export type IStoreState<
  T extends ValidIdItem & CollectionTypes,
  ID extends ValidIdItem['id'] = T['id'],
> = {
  items?: T[];
  lookup?: Record<ID, T>;
  isLoading?: boolean;
  isUpdating?: boolean;
  isDeleting?: boolean;
  isCreating?: boolean;
  error?: string;
  delete: (id: ID) => Promise<void>;
  update: (item: SemiPartial<T, 'id'>) => Promise<T>;
  create: (item: T) => Promise<T>;
  fetch: (organization: string) => Promise<T[]>;

  updateLocally: (
    args: UpdateClientData<T> & {
      options?: Partial<
        Pick<
          IStoreState<T, ID>,
          'isLoading' | 'isUpdating' | 'isDeleting' | 'isCreating'
        >
      >;
    },
  ) => void;
};
